<template>
  <div class="page-history">
    <div style="padding-top: 8px">
      <div id="icon-history" class="cs-history-header">
        <div style="display: flex; justify-content: center">
          <!--        <img src="@/static/icon_history_home.png" width="15"-->
          <!--             height="15" alt=""/>-->
          <!--        <van-icon name="user-o" color="#005D85" size="16" />-->
          <div
            v-if="getfullName"
            style="
              font-size: 13px;
              margin-left: 4px;
              color: #005d85;
              text-decoration-color: #005d85 !important;
              text-transform: capitalize;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div style="margin-right: 4px">
              {{ $t("welcome") }},
              <span style="font-weight: 600">
                {{ getfullName }}
              </span>
            </div>
            <!--          <div style="font-weight: 600" class="fullname-container"> Nguyen Tuan Kiet</div>-->
          </div>
          <div
            v-else
            style="
              font-size: 13px;
              margin-left: 4px;
              color: #005d85;
              text-decoration-color: #005d85 !important;
              text-transform: capitalize;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div style="margin-right: 4px">
              {{ $t("welcome") }},
              <span style="font-weight: 600"> Steven Nguyen </span>
            </div>
            <!--          <div style="font-weight: 600" class="fullname-container"> Nguyen Tuan Kiet</div>-->
          </div>
          <!--        <div v-if="getfullName" style="font-size: 13px; margin-left: 4px; color: #005D85; text-decoration-color: #005D85 !important; text-transform: capitalize; display: flex">-->
          <!--        <span  style="margin-right: 4px">{{$t("welcome")}},</span>  <span style="font-weight: 600" class="fullname-container">{{getfullName}}</span> </div>-->
        </div>
        <!--      <div style="display: flex; justify-content: center; align-items: center">-->
        <!--        <img src="@/static/icon_history_home.png" width="15"-->
        <!--             height="15" alt=""/>-->
        <!--        <a @click="handleGoToHistory('/history')" style="font-size: 15px; margin-left: 4px; color: #005D85; text-decoration-color: #005D85 !important; text-decoration-line: underline;">-->
        <!--          {{ $t('history')}}</a>-->
        <!--      </div>-->
      </div>
    </div>

    <van-tabs
      id="parentElement1"
      class="metfone-tab"
      :background="color_primary()"
      color="#fff"
      v-model:active="activeName"
      type="card"
      :sticky="false"
    >
      <van-tab name="myServices">
        <template #title>
          <div class="metfone-tab-header">
            {{ $t("my_services") }}
          </div>
        </template>
        <div>
          <template v-if="!loadingMyService">
            <metfone-loading />
          </template>
          <template v-else-if="checkArray(myServices) && myServices.length > 0">
            <div
              v-for="(value, index) in myServices"
              :key="index"
              style="margin-bottom: 10px"
            >
              <PostMetfoneService
                @click="handleShowDetailPackage(true, value)"
                type="myservices"
                :show-expired="true"
                :data="value"
                :show-renew="false"
                :show-status="false"
                @handleIsShowConfirm="handleIsShowConfirm"
              />
            </div>
          </template>

          <template
            v-else-if="!checkArray(myServices) && !isObjectEmpty(myServices)"
          >
            <div style="padding: 8px 0px">
              <PostMetfoneService
                @click="handleShowDetailPackage(true, myServices)"
                type="myservices"
                :show-expired="true"
                :data="myServices"
                :show-renew="false"
                :show-status="false"
                @handleIsShowConfirm="handleIsShowConfirm"
              />
            </div>
          </template>
          <template v-else>
            <data-notify :content="$t('not_services')" />
          </template>

          <!--          <InfiniteLoading style="display: flex; justify-content: center" @infinite="getListMyService2" >-->
          <!--            <template #spinner>-->
          <!--              <div class="loader"></div>-->
          <!--            </template>-->
          <!--            <template #complete>-->
          <!--              <div class="no-more"></div>-->
          <!--            </template>-->
          <!--          </InfiniteLoading>-->
        </div>
      </van-tab>
      <van-tab name="history">
        <template #title>
          <div class="metfone-tab-header">
            {{ $t("history") }}
          </div>
        </template>
        <div>
          <template v-if="!loadingHistories">
            <metfone-loading />
          </template>
          <template
            v-else-if="checkArray(listHistory) && listHistory.length > 0"
          >
            <div
              v-for="(value, index) in listHistory"
              :key="index"
              style="margin-bottom: 10px"
            >
              <PostMetfoneService
                @click="handleShowDetailPackageHistory(true, value)"
                type="history"
                :show-expired="true"
                :data="value"
                :show-renew="false"
                :show-status="true"
              />
            </div>
          </template>
          <template
            v-else-if="!checkArray(listHistory) && !isObjectEmpty(listHistory)"
          >
            <div style="padding: 8px 0px">
              <PostMetfoneService
                @click="handleShowDetailPackageHistory(true, listHistory)"
                type="history"
                :show-expired="true"
                :data="listHistory"
                :show-renew="false"
                :show-status="true"
              />
            </div>
          </template>
          <template v-else>
            <data-notify :content="$t('not_histories')" />
          </template>
          <InfiniteLoading
            style="display: flex; justify-content: center"
            @infinite="getListHistory"
          >
            <template #spinner>
              <div class="loader"></div>
            </template>
            <template #complete>
              <div class="no-more"></div>
            </template>
          </InfiniteLoading>
        </div>
      </van-tab>
    </van-tabs>
    <van-popup
      v-model:show="showCenter"
      round
      :style="{ padding: '0px', width: '80vw', maxWidth: '300px', top: '40vh' }"
      position="center"
    >
      <div v-if="detailModel && detailModel.name">
        <div style="background-color: #005d85">
          <div
            class="popup-header"
            :style="{ backgroundImage: `url(${imageUrl})` }"
          >
            <h6
              style="
                margin: 0px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-size: 16px;
                padding: 0px 24px;
              "
            >
              {{ detailModel.name }}
            </h6>
            <van-button
              class="btn-closed-detail-package"
              @click="handleShowDetailPackage(false, null)"
              size="24"
            >
              <img
                src="@/assets/images/icon-closed-header.png"
                width="16"
                height="16"
              />
            </van-button>
          </div>
        </div>

        <div class="popup-body">
          <h5
            v-if="detailModel.type == 'myservice'"
            style="margin: 5px 0px; font-weight: 600; font-size: 14px"
          >
            {{ $t("Remaining Package's Balance") }}
          </h5>
          <h5
            v-if="detailModel.type == 'history'"
            style="margin: 5px 0px; font-weight: 600; font-size: 14px"
          >
            {{ $t("PackageInformation") }}
          </h5>

          <div class="detail-card-description" v-if="detailModel.fullDes">
            <div v-html="detailModel.fullDes"></div>
          </div>
          <!--        <ul style="list-style-type: disc; padding-left: 20px; margin-top: 10px;">-->
          <!--          <li style="font-weight: 400; font-size: 12px;margin-bottom: 10px;">Phone number: 038 231 2412</li>-->
          <!--          <li style="font-weight: 400; font-size: 12px;margin-bottom: 10px;">Data: 3GB/5GB</li>-->
          <!--          <li style="font-weight: 400; font-size: 12px;margin-bottom: 10px;">Mins onnet call: 40 Mins/100 Mins</li>-->
          <!--          <li style="font-weight: 400; font-size: 12px;margin-bottom: 10px;">SMS onset: 50SMS/100 SMS</li>-->
          <!--          <li style="font-weight: 400; font-size: 12px;margin-bottom: 10px;">Mins offnet call: 0 Mins/0 Mins</li>-->
          <!--          <li style="font-weight: 400; font-size: 12px;margin-bottom: 10px;">Expired date: 22/12/2024</li>-->
          <!--        </ul>-->
        </div>
      </div>
    </van-popup>
    <div class="version-code">{{ $t("version") }} {{ versionCode }}</div>
  </div>
</template>

<script src="./index.js"></script>
<style src="./index.css" lang="css"></style>
